import React, { useCallback, useState } from "react"

import OutsideClickHandler from "react-outside-click-handler"
import { Button } from "@mui/material"
import MuiThemeProvider from "@web/components/Forms/MuiThemeProvider"

import styles from "./VariableEditor.module.scss"

interface Props {
  onDone: (text: string) => void
}

export function VariableEditor({ onDone }: Props) {
  const [text, setText] = useState("")

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value)
  }, [])

  const handleSubmit = useCallback(
    (e: { preventDefault: () => void }) => {
      e.preventDefault()

      onDone(text)
    },
    [onDone, text]
  )

  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        handleSubmit(e)
      } else if (e.key === "Escape") {
        e.preventDefault()
      }
    },
    [handleSubmit]
  )

  const handleClickOutside = useCallback(() => {
    onDone("")
  }, [onDone])

  return (
    <MuiThemeProvider>
      <OutsideClickHandler onOutsideClick={handleClickOutside}>
        <div className={styles.root}>
          <div className={styles.inner}>
            <input value={text} onChange={handleInputChange} onKeyDown={handleInputKeyDown} autoFocus />
            <Button onClick={handleSubmit} size="medium" type="button">
              Save
            </Button>
          </div>
        </div>
      </OutsideClickHandler>
    </MuiThemeProvider>
  )
}
